export default "/images/big_sis_logo.svg"